export default __webpack_public_path__ + "static/media/edited-17.c7111a7c.jpg";